import { jsxs, jsx } from 'react/jsx-runtime';
import { CrispSimilarIcon } from '@fabric-app/icons/icons';
import { Button } from '@fabric-app/ui/components/Button';
import React__default from 'react';
import { styled } from 'styled-components';

const StyledButton = styled(Button).attrs((p) => {
  return {
    size: "xs",
    ...p
  };
}).withConfig({
  displayName: "SimilarItemsInlineButton__StyledButton",
  componentId: "sc-90b9f62d-0"
})([
  `background:linear-gradient(97.34deg,#0c6dff 16.09%,#8118d3 84.01%);color:white;font-size:14px;font-weight:500;padding:5.5px 8px;border-radius:6px;`
]);
const SimilarItemsInlineButton = /* @__PURE__ */ React__default.forwardRef(({ type = "button", ...props }, ref) => {
  return /* @__PURE__ */ jsxs(StyledButton, {
    ...props,
    type,
    ref,
    children: [
      /* @__PURE__ */ jsx(CrispSimilarIcon, {}),
      " Similar"
    ]
  });
});
SimilarItemsInlineButton.displayName = "SimilarItemsInlineButton";

export { SimilarItemsInlineButton as default };
//# sourceMappingURL=SimilarItemsInlineButton.js.map
